module.exports = __webpack_public_path__ + "static/media/Incubation-program.5631616d.jpg";